import { render, staticRenderFns } from "./PdfExport.vue?vue&type=template&id=20f88552&scoped=true"
import script from "./PdfExport.vue?vue&type=script&lang=js"
export * from "./PdfExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f88552",
  null
  
)

export default component.exports